import useTranslation from 'next-translate/useTranslation';
import { ChangeEvent, FocusEvent, useState } from 'react';
import CaretDownIcon from '@/components/icons/CaretDownIcon';
import RightIcon from '@/components/icons/RightIcon';
import Paragraph from '@/components/Paragraph';
import RoundedBottomDrawer from '@/components/RoundedBottomDrawer';
import styles from '@/styles/TextField.module.css';
import { Option } from '@/utils/address';
import { withSpecialCharFilter } from '@/utils/validation';
interface Props {
  autoComplete?: string;
  autofocus?: boolean;
  disabled?: boolean;
  dropdownTitle?: string;
  error?: boolean;
  errorText?: string;
  id?: string;
  isDropDown?: boolean;
  label?: string;
  name: string;
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  onDisabledClick?: VoidFunction;
  options?: Option[];
  required?: boolean;
  testId?: string;
  value: string | number;
  isPreFilledCountryCode?: boolean;
}
const TextField = ({
  autoComplete = 'off',
  autofocus,
  disabled,
  dropdownTitle = '',
  error,
  errorText,
  id,
  isDropDown = false,
  label,
  name,
  onBlur,
  onChange,
  onDisabledClick,
  options = [],
  required,
  testId,
  value,
  isPreFilledCountryCode
}: Props) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const {
    t
  } = useTranslation('common');
  let selectedId = NaN;
  if (isDropDown) {
    selectedId = Number(options.find(o => o.name === value)?.id);
  }
  return <div className="relative" onClick={!disabled ? isDropDown ? () => {
    setShowDropdown(true);
  } : undefined : onDisabledClick} data-sentry-component="TextField" data-sentry-source-file="TextField2.tsx">
      <div className={`px-4 pt-6 border-[1px] rounded-lg relative ${error ? 'border-error-90' : 'border-neutral-30'} ${disabled ? 'text-neutral-50' : ''}`}>
        {isPreFilledCountryCode && <aside className="top-[1px] left-[1px] absolute flex justify-center items-center bg-neutral-10 rounded-l-md w-16 font-medium text-neutral-90 text-lg" style={{
        height: 'calc(100% - 2px)'
      }}>
            +91
          </aside>}
        <input id={id || name} name={name} type={isPreFilledCountryCode ? 'tel' : 'text'} inputMode={isPreFilledCountryCode ? 'numeric' : 'text'} pattern={isPreFilledCountryCode ? '[0-9]*' : ''} className={`appearance-none block outline-none w-full bg-transparent pb-1.5 ${isPreFilledCountryCode ? 'pl-16' : null}  ${styles.textfield2}`} placeholder=" " value={value} onChange={withSpecialCharFilter(onChange)} onBlur={onBlur} disabled={disabled || showDropdown} autoComplete={autoComplete} data-testid={testId} autoFocus={autofocus} />
        {label ? <label htmlFor={id} className={`top-[10px]  absolute pt-2 text-neutral-50 text-sm pointer-events-none ${isPreFilledCountryCode ? 'left-20' : null}`}>
            {label}
            {required && <span className="text-error-90">*</span>}
          </label> : ''}
        {isDropDown && <CaretDownIcon className="right-0 bottom-4 absolute fill-transparent stroke-2 stroke-primary-100 w-8 h-4" />}
      </div>
      {error && <Paragraph className="mt-1 ml-1 text-error-90">
          {required && value === '' ? t('required') : errorText}
        </Paragraph>}
      {isDropDown && <RoundedBottomDrawer onClose={() => setShowDropdown(false)} show={showDropdown} title={dropdownTitle}>
          <div className="mt-4 max-h-80 overflow-y-auto">
            {options.map(o => {
          const isSelected = Number(selectedId) === Number(o.id);
          return <button className={`border-b border-neutral-20 flex items-center justify-between last:border-b-0 py-3 w-full ${isSelected ? 'text-primary-100' : ''}`} key={o.id} onClick={() => {
            onChange?.({
              target: {
                name,
                value: o.name,
                id: o.id
              }
            } as unknown as ChangeEvent<HTMLInputElement>);
            setShowDropdown(false);
          }}>
                  {o.name}
                  {isSelected && <RightIcon className="fill-primary-100 stroke-2" height={16} width={16} />}
                </button>;
        })}
          </div>
        </RoundedBottomDrawer>}
    </div>;
};
export default TextField;